<template>
    <div id="over-ons" class="wrapper">
        <div class="inner-content">
            <Heading title="Over ons" subtitle="Little Asia" />
            <p data-aos="fade-in">
                Gastvrouw Fanny Deng en Chef-Kok Beng Sing Lim staan graag voor u klaar om u een buitengewone eetervaring te geven in hun restaurant.
                Al meer dan 5 jaar zetten zij in Little Asia de gasten gerechten voor van hoge kwaliteit en met een mooie presentatie.
                Alle gerechten worden met zorg bereid en geserveerd.<br><br>

                U kunt ze vinden aan Kleiweg 87A in Rotterdam-Noord.
                Elke dag zijn ze geopend van 4 uur smiddags tot half 11 's avonds.
                Als u wilt komen eten, dan kunt u reserveren via het nummer <a href="tel:010 422 62 63"> 010 422 62 63</a>.
            </p>
        </div>
        <!-- <Slider /> -->
    </div>
</template>

<script>
import Heading from './sections/Heading'
// import Slider from './slider/Slider'
export default {
    components: { Heading },
}
</script>


<style lang="scss" scoped>
    .wrapper {
        padding: 4rem;
        text-align: center;
        background-color: #fff;
        .inner-content {
            h1 {
                display: inline-block;
                margin-top: 0;
                color: #e74c3c;
                font-size: 4em;
            }
            p {
                font-size: 1.2em;
                margin: 0 auto;
                width: 50%;
                a{
                    color: black;
                }
            }
        }

    }

@media screen and (max-width: 600px) {
    .wrapper {
        padding: 0 0 50px 0;
        padding-top: 2em;
        .inner-content {
            p {
                width: 90%;
            }

        }
    }
}
</style>
